<div class="discover-difference-gradient">
	<div class="discover-difference-container">
		<div class="row">
			<div class="col-xl-6 mb-5">
				<div
					style="
						box-shadow: -30px 30px 50px 15px #cadae6;
						border-radius: 40px;
					"
					class="difference-image-container"
				>
					<img
						width="100%"
						src="../../assets/img/Difference2.png"
						alt=""
					/>
				</div>
			</div>
			<div class="col-xl-6">
				<h2 class="differnce-header">Discover Our Difference</h2>
				<div class="mt-5">
					<div class="d-flex mb-4">
						<img
							class="difference-list-image"
							src="../../assets/img/architecture.png"
							alt=""
						/>
						<div>
							<strong class="difference-list-head"
								>Seamless Architecture</strong
							>
							<ul class="mt-2 difference-list">
								<li>Install in minutes; not months like our competition</li>
								<li>
									Deploy anywhere (Linux, Windows IIS, or our
									Virtual Appliance)
								</li>
								<li>Run on premises or in the cloud</li>
							</ul>
						</div>
					</div>
					<div class="d-flex mb-4">
						<img
							class="difference-list-image"
							src="../../assets/img/automation.png"
							alt=""
						/>
						<div>
							<strong class="difference-list-head"
								>Advanced Automation</strong
							>
							<ul class="mt-2 difference-list">
								<li>
									Easily integrate your systems with 100s of real-time APIs
								</li>
								<li>
									Human- and machine-readable output in NIST’s
									Open Security Controls Assessment Language
									(OSCAL)
								</li>
								<li>
									Out-of-the-box integrations with a growing
									number of platforms including Microsoft
									Teams, Slack, MITRE Security Assessment
									Framework (SAF), JIRA, Tenable, ServiceNow, and
									Wiz.io.
								</li>
							</ul>
						</div>
					</div>
					<div class="d-flex mb-4">
						<img
							class="difference-list-image"
							src="../../assets/img/flexibility.png"
							alt=""
						/>
						<div>
							<strong class="difference-list-head"
								>First-Rate Flexibility</strong
							>
							<ul class="mt-2 difference-list">
								<li>
									Rely on our wizards to quickly create compliance artifacts
								</li>
								<li>
									Easily consolidate tools with our multi-tenant
									architecture
								</li>
								<li>
									Reduce development costs with drag and drop
									configuration with no code
								</li>
							</ul>
						</div>
					</div>
					<a href="/technology"
						><button class="get-to-know-btn bg-white py-2 px-4">
							Get to Know Our Tech
							<i
								class="ml-2 fas fa-long-arrow-alt-right"
							></i></button
					></a>
				</div>
			</div>
		</div>
	</div>
</div>
